import $ from '../../../utils/request'
const subUrlPrefix = 'paper/list'

// 查询节点关联题目
export function listPaper(query) {
    return $.get(subUrlPrefix, query)
}


// 查询题目的所有选项
export function listOptions(query) {
    return $.get("paper/listOptions", query)
}


// 新增节点关联题目
export function insertPaper(data) {
    return $.post("paper/insert", JSON.stringify(data), { contentType: 'application/json' });
}

// 删除节点关联题目
export function deletePaper(data) {
    return $.delete("paper/delete", data)
}

// 新增节点
export function insertTree(data) {
    return $.post("paperTree/insert", data)
}

// 查询所有节点
export function queryTree() {
    return $.get("paperTree/list")
}

// 删除树节点
export function deleteTree(data) {
    return $.post("paperTree/delete",JSON.stringify(data), { contentType: 'application/json' })
}

// 删除数值填空题取值范围
export function deleteVacantNum(data) {
    return $.delete("paper/deleteVacantScore",data)
}


// 删除数值填空题题目内容
export function deleteVacant(data) {
    return $.delete("paper/deleteVacant",data)
}


// 删除单选多选题选项
export function deleteOption(data) {
    return $.delete("paper/deleteOption",data)
}


// 查询所属分类
export function queryClassify() {
    return $.get("paper/queryClassify")
}


// 新增所属分类
export function saveClassify(data) {
    return $.post("paper/saveClassify",JSON.stringify(data), { contentType: 'application/json' })
}


const paperItemUrlPrefix = 'paperItem'

export function saveQuestion(data) {
    return $.post(paperItemUrlPrefix, data)
}

export function find(query) {
    return $.get(paperItemUrlPrefix, query)
}

export function submit(data) {
    return $.post(paperItemUrlPrefix + '/submit', data)
}
